// extracted by mini-css-extract-plugin
module.exports = {"icon":"FontAwesomeIcon_icon___iF9x","icon__bg":"FontAwesomeIcon_icon__bg__1K6e3"};